<template>
  <g>
    <path
      :d="region.path"
      @click="clickHandler"
      @mouseover="mouseoverHandler($event)"
      @mouseout="$emit('region-mouseout', $event)"
      class="path"
      :class="{ 'is-active': isActive }"
    >
    </path>
  </g>
</template>

<script>
export default {
  name: 'MapPath',
  props: {
    region: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
    },
    isActive: {
      type: Boolean,
    }
  },
  methods: {
    clickHandler() {
      if (this.disabled) return;

      this.$emit('region-click', this.region.regionCode);
    },
    mouseoverHandler(event) {
      const payload = {
        event,
        regionName: this.region.regionName,
      }
      this.$emit('region-mouseover', payload);
    },
  },
};
</script>

<style scoped lang="scss">
.path {
  &.is-active {
    fill: #77daa1;
  }
}
</style>
